import React from 'react';

const HomeLoanConfirmation = ({ formData, setCurrentStep }) => {
  // This data will eventually be updated dynamically once you connect your backend API
  const loanData = {
    bankName: "Kotak Mahindra Bank",
    loanType: "Home Loan",
    status: "Active",
    outstandingAmount: "₹72,00,000",
    currentEmi: "₹57,200/month",
    remainingTenure: "15 yrs, 3 mos",
    interestRate: "11.50% p.a."
  };

  return (
    <div 
      className="flex flex-col min-h-[100dvh] w-full max-w-[400px] mx-auto bg-gray-50 antialiased text-[#111827]"
      style={{ fontFamily: '"SF Pro", "SF Pro Display", -apple-system, sans-serif' }}
    >
      
      {/* 1. Header Section */}
      <div className="pt-6 pb-5 px-6 bg-white flex-none">
        <div className="flex items-center justify-between mb-6">
          {/* Back Icon - Navigates back to Step 1 */}
          <button 
            onClick={() => setCurrentStep(1)} 
            className="text-gray-800 focus:outline-none"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
          </button>
          
          {/* Progress Bar */}
          <div className="flex-1 mx-4 flex items-center">
            <div className="h-[7px] flex-1 bg-[#c9f7e0] rounded-full overflow-hidden">
              <div className="h-full bg-[#12F280] w-1/2"></div>
            </div>
          </div>
          <span className="text-xs text-gray-500 font-medium">2/4</span>
        </div>
        
        <h1 className="text-[24px] font-bold tracking-tight mb-1.5 text-gray-900">We found your home loan</h1>
        <p className="text-gray-500 text-[14px]">Please confirm if this is the home loan you want to transfer.</p>
      </div>

      {/* 2. Content Card Section - INCREASED WIDTH */}
      {/* Used px-6 on the parent and removed inner margins so the box expands fully */}
      <div className="px-6 flex-1 bg-gray-50 pt-6">
        <div className="bg-white rounded-[20px] border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] p-5">
          
          {/* Bank Info Header */}
          <div className="flex items-center mb-5">
            <div className="w-[42px] h-[42px] bg-[#ea4335] rounded-[10px] flex items-center justify-center mr-3.5 shadow-sm">
               <span className="text-white font-bold text-lg text-center leading-none">
                 &infin;
               </span>
            </div>
            <div>
              <h2 className="text-[15.5px] font-bold text-gray-900 leading-tight mb-0.5">{loanData.bankName}</h2>
              <div className="flex items-center">
                <span className="text-[12.5px] text-gray-500 mr-2">{loanData.loanType}</span>
                <span className="text-[10px] font-bold text-[#16a34a] bg-[#f0fdf4] px-2 py-0.5 rounded-full border border-[#bbf7d0]">
                  {loanData.status}
                </span>
              </div>
            </div>
          </div>

          {/* Loan Details List */}
          <div className="space-y-0">
            {/* Row 1 */}
            <div className="flex justify-between items-center border-b border-gray-100 py-3.5">
              <span className="text-[13px] font-medium text-gray-500 w-1/2 leading-snug">Outstanding Loan<br/>Amount</span>
              <span className="text-[16.5px] font-bold text-gray-900 tracking-tight">{loanData.outstandingAmount}</span>
            </div>
            
            {/* Row 2 */}
            <div className="flex justify-between items-center border-b border-gray-100 py-3.5">
              <span className="text-[13px] font-medium text-gray-500">Current EMI</span>
              <span className="text-[15.5px] font-bold text-gray-900 tracking-tight">{loanData.currentEmi}</span>
            </div>

            {/* Row 3 */}
            <div className="flex justify-between items-center border-b border-gray-100 py-3.5">
              <span className="text-[13px] font-medium text-gray-500">Remaining Tenure</span>
              <span className="text-[15.5px] font-bold text-gray-900 tracking-tight">{loanData.remainingTenure}</span>
            </div>

            {/* Row 4 */}
            <div className="flex justify-between items-center pt-3.5 pb-1">
              <span className="text-[13px] font-medium text-gray-500">Current Interest Rate</span>
              <span className="text-[15.5px] font-bold text-gray-900 tracking-tight">{loanData.interestRate}</span>
            </div>
          </div>
        </div>
      </div>

      {/* 3. Action Area Section */}
      <div className="px-6 pb-8 pt-4 bg-gray-50 flex-none z-10">
        <p className="text-center text-[13.5px] font-bold text-gray-900 mb-4">Is this the home loan you want to transfer?</p>
        
        {/* Continue Button - SLIMMER HEIGHT (py-3.5 instead of py-4) */}
        <button 
          onClick={() => setCurrentStep(4)}
          className="w-full bg-black text-white font-medium py-3.5 rounded-[16px] text-[16px] active:scale-[0.98] transition-transform shadow-md"
        >
          Yes, Continue
        </button>
      </div>
      
    </div>
  );
};

export default HomeLoanConfirmation;